<div mat-dialog-title>
  <h1 style="display: flex;align-items: center;margin:0;padding: 5px 0 0 0;font-size:22px;font-weight:bold;">
    Import Inventory
  </h1>
  <app-dialog-close-button layoutMode="float" (click)="close()"></app-dialog-close-button>
</div>
<hr>
<h3>Get Single Vehicle</h3>
<p>Loading a single vehicle typically takes less then 15 seconds.</p>
<div style="display: flex;gap:5px;align-items: center">
  <input placeholder="Enter VIN" [ngModel]="getInventoryVin" (ngModelChange)="updateGetInventoryVin($event)"
         style="padding: 0 8px;min-width:240px;border-radius: 4px;height:36px;border:1px solid #ccc">
  <button mat-button class="blue-button" (mousedown)="getInventoryForVin()" [disabled]="!getInventoryVin">
    Get Single Vehicle
  </button>
</div>
<hr>
<h3>Get All Vehicles</h3>
<p>Retrieving all vehicles may take up to 1 hour.</p>
<div style="display: flex;gap:5px;align-items: center;margin-bottom:16px">
  <button mat-button class="blue-button" (mousedown)="getAllInventory()">Get All Inventory</button>
</div>
